import React from 'react';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZE = { sm: 'w-4 h-4', md: 'w-6 h-6', lg: 'w-10 h-10' };

export default function Spinner({ size = 'md', className = '' }: SpinnerProps) {
  return (
    <div
      className={`${SIZE[size]} border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin ${className}`}
      role="status"
      aria-label="loading"
    />
  );
}
